// Shuffle a complete round, keeping its first claim different from the last one shown.
export function shuffleClaims(count, previous, random = Math.random) {
  const order = Array.from({ length: count }, (_, index) => index)
  for (let index = order.length - 1; index > 0; index--) {
    const other = Math.floor(random() * (index + 1))
    ;[order[index], order[other]] = [order[other], order[index]]
  }
  if (order.length > 1 && order[0] === previous) {
    ;[order[0], order[1]] = [order[1], order[0]]
  }
  return order
}
